import $ from 'jquery';

import {
  getElement,
  SITE_BODY,
  SITE_HEADER,
  COMPACT_CLASS
} from './site-variables';

const siteHeader = () => {
  console.log('siteHeader init');
  // Private vars:
  let didScroll;
  let lastScrollTop = 0;
  let delta = 200;

  // Private: event handler for scroll
  $(document).scroll(() => {
    didScroll = true;
  });

  // Private: Check if scroll every 250ms
  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  // Private: toggle class for header element
  const hasScrolled = () => {
    var distFromTop = $(global).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - distFromTop) <= delta) {
      return;
    }
    // If they scrolled down and are past the navbar, add class .nav-compressed.
    // This is necessary so you never see what is "behind" the navbar.
    if (distFromTop > lastScrollTop && distFromTop > getSiteHeaderHeight()) {
      getElement(SITE_BODY).addClass(COMPACT_CLASS);
    }
    else {
      getElement(SITE_BODY).removeClass(COMPACT_CLASS);
    }
    lastScrollTop = distFromTop;
  };
};

const getSiteHeaderHeight = () => {
  return getElement(SITE_HEADER).height();
};

export default siteHeader;
